var $192599a4a9cf1fdc$exports = {};
$192599a4a9cf1fdc$exports = {
    "valid": `G\xfcltig`
};


export {$192599a4a9cf1fdc$exports as default};
//# sourceMappingURL=de-DE.module.js.map
